import { listAccountMasterv3Api } from '../../../features/AccountsAndGroups/api/accountMaster.api';
import { listGroupMasterApi } from '../../../redux/apis/accountGroupMaster.api';
import { listAccountMasterv2Api } from '../../../redux/apis/accountMaster.api';
import { listAccountOpeningBalanceApi } from '../../../redux/apis/accountOpeningBalance.api';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import type { AppDispatch } from '../../../redux/types';

/** Invalidate RTK caches used to build Balance Sheet / Trial Balance / Receivables trees. */
export const invalidateDashboardMasterCaches = (dispatch: AppDispatch): void => {
  dispatch(dashboardApi.util.invalidateTags(['dashboard']));
  dispatch(listGroupMasterApi.util.invalidateTags(['listGroupMaster']));
  dispatch(listAccountMasterv2Api.util.invalidateTags(['listAccountMaster', 'allaccounts']));
  dispatch(listAccountMasterv3Api.util.invalidateTags(['listAccountMaster', 'allaccounts', 'partyDetailsByAccountId']));
  dispatch(listAccountOpeningBalanceApi.util.invalidateTags(['listAccountOpeningBalance']));
};
